module.exports = __webpack_public_path__ + "img/male.4024bc0c.png";